// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".person-icon[data-v-ccd659e0]{margin:-22px}.profile-photo[data-v-ccd659e0]{border-radius:50%}button[data-v-ccd659e0]:disabled{background:var(--v-accentPurpleTransparent-base);filter:none!important;opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
